import React, { useEffect, useState } from "react";
import { Form, Input, Select } from "antd";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useOrgAndRelatedOrgInput } from "../hooks";
import { getAllBranches, procurementCreateAction } from "../store/org";

const ProcurementsForm = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { loadingOrg } = useOrgAndRelatedOrgInput();
  const { user } = useSelector((state) => state.users);
  const {
    org: { branches },
  } = useSelector((state) => ({
    org: state.org,
  }));
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    setLoading(true);
    await dispatch(
      procurementCreateAction({
        ...values,
      })
    );
    setLoading(false);
    form.resetFields();
  };

  useEffect(() => {
    let queryString = ''
    if (["LM", "UM", "BAG", "BHOA"].includes(user.position)) {
      queryString = `id=${user?.branch?.id}`
    }
    dispatch(getAllBranches(queryString));
  }, [])

  return (
    <Container fluid>
      <h3 className="page-title mb-4">Add procuremnts</h3>

      <Form form={form} onFinish={handleSubmit}>
        <Row>
          <Col md="6">
            <Form.Item
              name="branch_id"
              rules={[
                {
                  required: true,
                  message: "Please select an option",
                },
              ]}
              label="Branches"
            >
              <Select
                showSearch
                optionFilterProp="children"
                className="custom-input"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input?.toLowerCase()) >=
                  0
                }
                allowClear
                placeholder="Select a branch"
              >
                {branches?.map(({ id, name }) => (
                  <Select.Option value={id} key={id}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col className="" md="6">
            <Form.Item
              name="date"
              label="Date"
              rules={[
                {
                  required: true,
                  message: "Please provide date",
                },
              ]}
            >
              <Input placeholder="Date" type="date" className="form-control" />
            </Form.Item>
          </Col>

          <Col className="" md="6">
            <Form.Item
              name="asset_name"
              label="Asset Name"
              rules={[
                {
                  required: true,
                  message: "Please provide asset name",
                },
              ]}
            >
              <Input placeholder="Name" type="text" className="form-control" />
            </Form.Item>
          </Col>

          <Col className="" md="6">
            <Form.Item
              name="amount"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Please provide amount",
                },
              ]}
            >
              <Input
                placeholder="Amount"
                type="number"
                className="form-control"
              />
            </Form.Item>
          </Col>

          <Col className="" md="6">
            <Form.Item
              name="quantity"
              label="Quantity"
              rules={[
                {
                  required: true,
                  message: "Please provide quantity of asset/material",
                },
              ]}
            >
              <Input
                placeholder="Quantity"
                type="number"
                className="form-control"
              />
            </Form.Item>
          </Col>

          <Col md="6">
            <Form.Item
              name="procurement_type"
              rules={[
                {
                  required: true,
                  message: "Please an an option",
                },
              ]}
              label="Type of procurement"
            >
              <Select
                showSearch
                optionFilterProp="children"
                className="custom-input"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input?.toLowerCase()) >=
                  0
                }
                placeholder="Asset / Material"
                allowClear
              >
                <Select.Option value="asset" key={1}>
                  Asset
                </Select.Option>
                <Select.Option value="material" key={2}>
                  Material
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Button
              variant="primary"
              className="px-5"
              disabled={loadingOrg || loading}
              type="submit"
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export { ProcurementsForm };
